import { Select2OptionData } from "ng-select2";

export const ARR_TYPE_EMPLOYER: Array<{ id: number, text: string, color: string }> =
    [
        { id: 1, text: 'Colegio Particular Pagado', color: 'custom-blue-8' },
        { id: 2, text: 'Colegio Particular Subvencionado', color: 'mid-gray' },
        { id: 3, text: 'Colegio Municipal', color: 'custom-blue-8' },
        { id: 4, text: 'Colegio Administración Delegada', color: 'custom-blue-8' },
        { id: 5, text: 'Red Escolar o Preescolar', color: 'custom-blue-8' },
        { id: 6, text: 'Sostenedor municipal', color: 'custom-blue-8' },
        { id: 7, text: 'Preescolar', color: 'custom-green-5' },
        { id: 8, text: 'Preuniversitario', color: 'custom-blue-8' },
        { id: 9, text: 'Instituto de Inglés', color: 'custom-blue-8' },
        { id: 10, text: 'Instituto Profesional', color: 'custom-blue-8' },
        { id: 11, text: 'Centro de Formación Técnica', color: 'custom-blue-8' },
        { id: 12, text: 'Universidad', color: 'custom-blue-8' },
        { id: 13, text: 'Educación online', color: 'custom-blue-8' },
        { id: 14, text: 'Otros', color: 'custom-blue-8' }
    ];

export const ID_TYPE_INSTITUTION_OTHERS: number = 14;

export const dataSelect2TypeEmployer: Array<Select2OptionData> = ARR_TYPE_EMPLOYER.map(x => { return { id: x.text, text: x.text, additional: x.id } as Select2OptionData });
